import constants from '@/constants';
import { Bridge } from '@/utils/bridge';
import { addQueryToUrl } from '@/utils/uri';
import { REMOVE_BACKGROUND_CODE } from '../dpConfig/dpConfig';

const {
  SHARE_MODULE: {
    WEBAPP_PROD_SUBDOMAIN,
    shareRouter: { DOWNLOAD }
  }
} = constants;

export const handleOpenApp = (
  type,
  asin = '',
  queryParams = '',
  isAnimated = true
) => {
  const url = new URL(location.href);
  const searchParams = url.searchParams;
  searchParams['delete']('isShare');
  Bridge.callFn('openNativePage', {
    url: addQueryToUrl(`${WEBAPP_PROD_SUBDOMAIN}/${DOWNLOAD}`, {
      target: `${WEBAPP_PROD_SUBDOMAIN}/${type}${`${
        asin ? `/${asin}` : ''
      }`}${`${
        queryParams || searchParams.toString()
          ? `?${queryParams || searchParams.toString()}`
          : ''
      }`}`
    }),
    animated: isAnimated
  });
};

/**
 * Decimal separator price splitting
 * @param {Number|String} price
 * @returns price
 */

const useSplitPrice = price => {
  if (!price) return 0;
  const ourPrice = Number(price).toFixed(2);
  return `${ourPrice}`.split('.');
};

/**
 * remove img background
 * @param {String} url
 * @returns url
 */

const removeImgBackground = url => {
  if (url.indexOf('.jpg') !== -1) {
    return url.replace('.jpg', `.${REMOVE_BACKGROUND_CODE}.jpg`);
  }
  return url;
};

const getAsinTwisterForCustomerReview = (reviewList, asinInfo) => {
  if (!asinInfo) return reviewList;
  reviewList = reviewList.map(review => {
    if (review?.asin) {
      review.reviewTwister = '';
      if (!asinInfo.twisterVariations?.variations) return review;
      const reviewTwister = asinInfo.twisterVariations.variations.filter(
        variation => variation.asin === review.asin
      )[0];
      asinInfo.twisterVariations.dimensionKeys.forEach((_, index) => {
        if (review?.reviewTwister) {
          review.reviewTwister = `${review.reviewTwister}，${
            asinInfo.twisterVariations.dimensionValues[index][
              reviewTwister.values[index]
            ]
          }`;
        } else {
          review.reviewTwister =
            asinInfo.twisterVariations.dimensionValues[index][
              reviewTwister.values[index]
            ];
        }
      });
    }
    return review;
  });
  return reviewList;
};

export { useSplitPrice, removeImgBackground, getAsinTwisterForCustomerReview };
